<template>
    <span class="animated-slide-up" :class="{ animate: shouldAnimate }">
        <slot>{{ value }}</slot>
    </span>
</template>

<script setup>
import { onMounted, ref, watch } from "vue";

const props = defineProps({
    value: { type: [Number, String], default: "" },
    delay: { type: Number, default: 0 },
    duration: { type: Number, default: 600 },
    distance: { type: Number, default: 30 },
    startOnMount: { type: Boolean, default: true },
});

const shouldAnimate = ref(false);

const animate = () => {
    shouldAnimate.value = false;
    setTimeout(() => {
        shouldAnimate.value = true;
    }, props.delay);
};

const reset = () => {
    shouldAnimate.value = false;
};

onMounted(() => {
    if (props.startOnMount) {
        animate();
    }
});

watch(
    () => props.value,
    () => {
        if (props.startOnMount) {
            animate();
        }
    },
);

defineExpose({ animate, reset });
</script>

<style scoped>
.animated-slide-up {
    display: inline-block;
    opacity: 0;
    transform: translateY(v-bind('distance + "px"'));
}

.animated-slide-up.animate {
    animation: slideUp v-bind('duration + "ms"') ease-out forwards;
}

@keyframes slideUp {
    0% {
        opacity: 0;
        transform: translateY(v-bind('distance + "px"'));
    }
    100% {
        opacity: 1;
        transform: translateY(0);
    }
}
</style>
